export default __webpack_public_path__ + "static/media/goals-new-logo.58de71e9.svg";